import { DeviceAdapterInterface } from "@citychallenge/core";

import { WEB_CONFIG } from "../web-config";

export class DeviceAdapter implements DeviceAdapterInterface {
  public getDeviceLanguage() {
    // TODO: Implement
    const full = navigator.language || "en-GB";

    return {
      full: full.toLowerCase(),
      short: full.split("-")[0].toLowerCase(),
    };
  }

  public getPreferredLanguages() {
    const languages = navigator.languages;

    return languages.map((lang) => {
      return {
        full: lang.toLowerCase(),
        short: lang.split("-")[0].toLowerCase(),
      };
    });
  }

  public getDevUrl() {
    return this.getApiPath();
  }

  public getApiPath() {
    if (window.location.hostname === "web.intractive.eu.ngrok.io") {
      return "https://api.intractive.eu.ngrok.io";
    }

    return WEB_CONFIG.API_URL;
  }

  public async getBatteryLevel() {
    return 1;
  }

  public async checkIsARSupported() {
    return "UNSUPPORTED" as const;
  }

  public async requestARInstall() {
    // TODO: Implement
  }

  public async hasGyroscope() {
    return false;
  }

  public async getInstallReferrer() {
    return "";
  }

  public async isEmulator() {
    return false;
  }
}
